var map = {
	"./blue.png": 428,
	"./blueViolet.png": 9773,
	"./default.png": 8105,
	"./green.png": 6703,
	"./lightBlue.png": 354,
	"./lightGreen.png": 593,
	"./orange.png": 8186,
	"./pink.png": 1500,
	"./purple.png": 5270,
	"./red.png": 4879,
	"./yellow.png": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4007;